import Img from './img-cross.png';

export function ImgCross() {
  return (
    <img
      src={Img}
      alt=""
      className="h-full max-h-[150px] w-full max-w-[150px] object-contain"
    />
  );
}
